import { apiClient } from '@/shared/api/client';

interface Envelope<T> {
  data: T;
  meta?: { correlationId: string; timestamp: string };
}

export interface HubSpotIdentity {
  /** Whether the signed-in user already exists as a HubSpot contact. */
  known: boolean;
}

/**
 * Asks whether the signed-in user is already a HubSpot contact.
 *
 * This is the cost control on the pixel, not a nicety. HubSpot has no API that
 * links a browser to a contact *only if that contact exists* — `identify` plus a
 * pageview is an upsert — so the "don't create anybody" half of the requirement
 * has to be decided here, before we ever call `identify`.
 *
 * Takes no argument on purpose: b2b-api reads the email from the session, so
 * there is no request field an attacker could pivot into a CRM membership
 * oracle. Do not add one.
 */
export const fetchHubSpotIdentity = async (): Promise<HubSpotIdentity> => {
  const res = await apiClient.get<Envelope<HubSpotIdentity>>(
    '/api/v1/analytics/hubspot-identity'
  );
  return res.data;
};
